import {View} from "./View"
export const ToggleSwitch = () =>{
    return(
        <View/>
    )
}